window.alert = {
    _toastBase: Swal.mixin({
        toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    }),

    _popupBase: Swal.mixin({
        position: 'top-center',
        showConfirmButton: false
    }),

    toast: function(message, type = 'success', params = {}){
        let settings = {
            icon: type,
            title: message,
            width: params.width ?? null,
            text: params.text ?? null,
            html: params.html ?? null,
            position: params.position ?? 'top',
            timer: params.timer ?? 3000
        }

        this._toastBase.fire(settings)
    },

    popup: function(message, type = 'success', params = {}){
        let settings = {
            icon: type,
            title: params.title ?? null,
            text: message,
            showCloseButton: params.showCloseButton ?? true,
            showCancelButton: params.showCancelButton ?? true,
            showConfirmButton: params.showConfirmButton ?? false,
            html: params.html ?? null,
            cancelButtonText: params.cancelButtonText ?? 'Close',
            allowOutsideClick: params.allowOutsideClick ?? true,
            confirmButtonText: params.confirmButtonText ?? "Okay",
            width: params.width ?? null
        };

        if(params.showLoading){
            settings['didOpen'] = () => {
                Swal.showLoading();
            }
        }

        const popup = this._popupBase.fire(settings);

        if(params.onConfirm){
            popup.then((result) => {
                if (result.isConfirmed) {
                    params.onConfirm();
                }
            })
        }
    },

    close: function (){
        Swal.close();
    }
}